export class ServicesEvaConstants {
  /// <summary>
  /// Permite listar documentos
  /// </summary>
  public static LIST_DOCUMENTS = 'LIT1001';
  /// <summary>
  /// Permite el acceso al Dashboard
  /// </summary>
  public static USE_DASHBOARD = 'LIT1002';
  /// <summary>
  /// Permite la edición de documentos
  /// </summary>
  public static MANAGE_DOCUMENTS = 'LIT1003';
  /// <summary>
  /// Permite el uso de pagarés
  /// </summary>
  public static PROMISORY_NOTES = 'LIT1026';
  /// <summary>
  /// Permite consultar un documento
  /// </summary>
  public static VIEW_DOCUMENTS = 'LIT1004';
  /// <summary>
  /// Permite la firma de documentos
  /// </summary>
  public static SIGN_DOCUMENTS = 'LIT1005';
  /// <summary>
  /// Usuarios contratados y conteo de adicionales
  /// </summary>
  public static USERS = 'LIT1011';
  /// <summary>
  /// Documentos contratados y  conteo de adicionales
  /// </summary>
  public static DOCUMENTS = 'LIT1012';
  /// <summary>
  /// Permite compartir documentos
  /// </summary>
  public static SHARE_DOCUMENTS = 'LIT1013';
  /// <summary>
  /// Permite la descarga de un documento
  /// </summary>
  public static DOWNLOAD_DOCUMENTS = 'LIT1006';
  /// <summary>
  /// Permite el acceso al módulo de configuración
  /// </summary>
  public static APP_CONFIGURATION = 'LIT1007';
  /// <summary>
  /// Permite la edición del perfil del cliente
  /// </summary>
  public static EDIT_PROFILE = 'LIT1008';
  /// <summary>
  /// Permite el uso del API
  /// </summary>
  public static USE_API = 'LIT1021';
  /// <summary>
  /// Permite el uso de Elastic Search
  /// </summary>
  public static FREE_SEARCH = 'LIT1009';
  /// <summary>
  /// Permite el uso del Drive y Minio
  /// </summary>
  public static STORAGE = 'LIT1010';
  /// <summary>
  /// Permite el uso de plantillas
  /// </summary>
  public static TEMPLATES = 'LIT1018';
  /// <summary>
  /// Permite el uso de CLM (Genera, revisa, autoriza)
  /// </summary>
  public static DIGITAL_LEGAL_COLLABORATION = 'LIT1027';
  /// <summary>
  /// Permite el uso de usuarios colaboradores
  /// </summary>
  public static COLLABORATOR = 'LIT1014';
  /// <summary>
  /// Permite el registro multi compañías
  /// </summary>
  public static MULTI_COMPANIES = 'LIT1015';
  /// <summary>
  /// Permite crear perfiles personalizados a usuarios
  /// </summary>
  public static USER_PROFILES = 'LIT1017';
  /// <summary>
  /// Permite registrar firmas con biométricos
  /// </summary>
  public static BIOMETRICS_SIGN = 'LIT1023';
  /// <summary>
  /// Permite configurar el Look and Feel
  /// </summary>
  public static LOOKANDFEEL_CONFIG = 'LIT1016';
  /// <summary>
  /// Permite obtener la configuracion de token rsa
  /// </summary>
  public static TOKEN_RSA = 'LIT1024';
  /// <summary>
  /// Permite utilizar Servicios SMS
  /// </summary>
  public static SMS = 'LIT1025';
  /// <summary>
  /// Permite obtener la configuracion cliente de correo
  /// </summary>
  public static EMAIL_CONFIG = 'LIT1019';
  /// <summary>
  /// Permite el uso de contratos
  /// </summary>
  public static CONTRACTS = 'LIT1020';
  /// <summary>
  /// Firma API - Setup Fee
  /// </summary>
  public static FIRMA_API_SETUP_FEE = 'LIT1022';
}
